module.exports = __webpack_public_path__ + "img/cta_split.aecebd51.png";